export default function WhistleIcon({ size = 24, className, weight: _weight, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path
        d="M5.6 8.2h8.1c2.55 0 4.62 2.07 4.62 4.62s-2.07 4.62-4.62 4.62H9.15c-2.63 0-4.75-2.13-4.75-4.75V9.4c0-.66.54-1.2 1.2-1.2Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.1 8.2 11.9 5h5.35l-2.73 3.24"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="13.7" cy="12.82" r="1.45" fill="currentColor" />
      <path
        d="M4.4 10.2H2.7"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
